import Vue from 'vue';
import Axios from 'axios';
import store from '@/store';
import utils from '@/utils/utils';
import isIE from '@/utils/isIE';
import { getToken } from '@/utils/session';

const {
  POST_API_CUSTOM_HEADER,
  csrfCookieName,
  csrfHeaderName,
} = Vue.$app;

Axios.defaults.headers.common.Accept = 'application/json';
Axios.defaults.headers.post[POST_API_CUSTOM_HEADER] = 1;
Axios.defaults.xsrfCookieName = csrfCookieName;
Axios.defaults.xsrfHeaderName = csrfHeaderName;

if (isIE()) {
  // Disable IE response cache
  Axios.defaults.headers.Pragma = 'no-cache';
}

Axios.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error),
);

Axios.interceptors.response.use(
  undefined,
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('user/clearToken');
      Vue.router.push({ name: Vue.$app.route.LOGIN });
    }
    // Handle CSRF re-try once
    if (error.response.status === 403) {
      const config = error.config;
      /* eslint no-underscore-dangle: 0 */
      if (config && !config.__retryRequest) {
        config.__retryRequest = true;
        // Remove baseUrl from url to prevent double prefix
        config.url = config.url.replace(config.baseURL, '');
        return Axios(config);
      }
    }
    return Promise.reject(error);
  },
);

const unwatch = store.watch(() => store.getters.baseUrlPath, (value) => {
  if (!utils.isUndefined(value)) {
    Axios.defaults.baseURL = value;
    store.dispatch('initHttp');
    unwatch();
  }
});

// Bind Axios to Vue.
Vue.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});
